const glassesPrescriptionTb1 = [
  {
    key: 1,
    none: "Xa",
    sph: "",
    cyl: "",
    Axis: "",
    vision: "",
  },
  {
    key: 2,
    none: "Add",
    sph: "",
    cyl: "",
    Axis: "",
    vision: "",
  },
  {
    key: 3,
    none: "Gần",
    sph: "",
    cyl: "",
    axis: "",
    vision: "",
  },
];

const glassesPrescriptionTb2 = [
  {
    key: 1,
    name: "Loại mắt kính",
  },
  {
    key: 2,
    name: "MPD",
  },
  { key: 3, type: "input", name: "Lời khuyên" },
];

const glassesPrescription = {
  tb1: glassesPrescriptionTb1,
  tb2: glassesPrescriptionTb2,
};
export default glassesPrescription;
